import React from "react";
import { colors } from "@/assets/themes";
import { Body16 } from "../../text";
import type { TitleProps } from "../types";

const Title = ({ children, ...rest }: TitleProps) => (
  <Body16 color={colors.body} {...rest}>
    {children}
  </Body16>
);

export default Title;
